import script from "./header.vue?vue&type=script&lang=ts&setup=true"
export * from "./header.vue?vue&type=script&lang=ts&setup=true"

import "./header.vue?vue&type=style&index=0&id=32c81c4f&lang=scss&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\client-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c81c4f"]])

export default __exports__